import React from "react";
import SidebarContent from "./SideBarContent";
import styles from "./SideBar.module.css";

const Sidebar = ({ fromNav }) => {
  return (
    <aside className={styles.sidebar}>
      <SidebarContent fromNav={fromNav} />
    </aside>
  );
};

export default Sidebar;
